import { useTheme } from '@emotion/react';
import { Icon } from '../Icon';

type NotFoundIconProps = Icon.Props & {
  iconRootProps?: React.HTMLAttributes<HTMLSpanElement>;
};

const NotFoundIcon = ({ iconRootProps, ...rest }: NotFoundIconProps) => {
  const theme = useTheme();
  return (
    <Icon
      data-testid="not-found-icon"
      height=".954em"
      rootProps={iconRootProps}
      viewBox="0 0 87 83"
      width="1em"
      {...rest}
    >
      <g fill="currentColor" fillRule="nonzero">
        <path
          d="M6.79658 81.4252C5.79568 81.4251 4.81185 81.1659 3.94086 80.6728C3.06987 80.1797 2.34141 79.4694 1.82637 78.6112C1.31134 77.753 1.02729 76.776 1.00187 75.7755C0.976453 74.7749 1.21053 73.7848 1.68133 72.9015L38.3873 4.06463C38.8822 3.13873 39.6191 2.36459 40.5196 1.82484C41.42 1.28509 42.4501 1 43.5 1C44.5498 1 45.5799 1.28509 46.4804 1.82484C47.3808 2.36459 48.1178 3.13873 48.6126 4.06463L85.3186 72.9015C85.7883 73.7826 86.0224 74.7701 85.9983 75.7683C85.9742 76.7664 85.6927 77.7415 85.181 78.5989C84.6694 79.4563 83.945 80.167 83.0779 80.6622C82.2109 81.1573 81.2307 81.4202 80.2322 81.4252H6.79658Z"
          fill="white"
          id="Vector"
          stroke={theme.palette.text.title}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M45.8514 53.8029C45.7188 54.3236 45.4166 54.7853 44.9924 55.115C44.5681 55.4448 44.0461 55.6238 43.5088 55.6238C42.9715 55.6238 42.4495 55.4448 42.0252 55.115C41.601 54.7853 41.2987 54.3236 41.1661 53.8029C35.0231 29.5952 35.4452 31.2942 35.4243 31.0399C35.3089 29.9088 35.4321 28.7662 35.7859 27.6857C36.1398 26.6053 36.7163 25.6111 37.4784 24.7673C38.2404 23.9236 39.171 23.2492 40.2099 22.7875C41.2489 22.3259 42.3732 22.0874 43.5101 22.0874C44.647 22.0874 45.7713 22.3259 46.8102 22.7875C47.8492 23.2492 48.7798 23.9236 49.5418 24.7673C50.3039 25.6111 50.8804 26.6053 51.2342 27.6857C51.588 28.7662 51.7113 29.9088 51.5959 31.0399C51.5723 31.2837 51.9997 29.5769 45.8514 53.8029Z"
          fill={theme.palette.contrastInverse}
          id="Vector_2"
          stroke={theme.palette.text.title}
          strokeWidth="2"
        />
        <path
          d="M49.819 65.9878C49.819 67.2364 49.4487 68.4571 48.755 69.4953C48.0613 70.5336 47.0753 71.3428 45.9216 71.8206C44.768 72.2985 43.4986 72.4235 42.2739 72.1799C41.0492 71.9363 39.9243 71.335 39.0413 70.452C38.1584 69.5691 37.5571 68.4441 37.3135 67.2194C37.0698 65.9948 37.1949 64.7253 37.6727 63.5717C38.1506 62.4181 38.9598 61.4321 39.998 60.7383C41.0363 60.0446 42.2569 59.6743 43.5056 59.6743C45.18 59.6743 46.7859 60.3395 47.9699 61.5235C49.1539 62.7075 49.819 64.3133 49.819 65.9878Z"
          data-testid="icon-path"
          fill={theme.palette.contrastInverse}
          id="Vector_3"
          stroke={theme.palette.text.title}
          strokeWidth="2"
        />
      </g>
    </Icon>
  );
};

export { NotFoundIcon };
